import config from '@/config'
export * from './websocket';
export * from './request';
export * from './stroage';
export * from './ui';
export * from './postmessage'

const { assetsURL } = config

/**
 * 深拷贝
 * @param { * } data 数据源
 * @returns {*}
 */
export function deepClone(data) {
	let d;
	try {
		d = structuredClone(data)
	} catch (_) {
		d = JSON.parse(JSON.stringify(data))
	}
	return d
}

/**
 * 对象深度合并
 * @param { Object } o1
 * @param { Object } o2
 * @returns {*}
 */
export function deepMerge(o1, o2) {
	let key;
	for (key in o2) {
		o1[key] = o1[key] && o1[key].toString() === "[object Object]" &&
			(o2[key] && o2[key].toString() === "[object Object]")
			? deepMerge(o1[key], o2[key]) : (o1[key] = o2[key]);
	}
	return o1
}

/**
 * 对象同字段数据合并
 * @param source 目标
 * @param target 数据
 */
export function mergeFields(target, source) {
	for (const key in source) {
		if (Object.hasOwn(target, key)) {
			Reflect.set(target, key, source[key])
		}
	}
}

/**
 * 格式化时间戳
 * @param { string, number } time 时间戳
 * @param { string } cFormat 格式化模板
 * @return { string } 时间戳格式化数据
 */
export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) return ''
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string')) {
			if ((/^[0-9]+$/.test(time))) {
				time = parseInt(time)
			} else {
				time = time.replace(new RegExp(/-/gm), '/')
			}
		}

		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	return format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
}

/**
 * 解析时间格式
 * @param { string | number} time 时间戳
 * @param { string } option 格式化模板
 * @return { string } 日期解析数据
 */
export function formatTime(time, option) {
	if (('' + time).length === 10) {
		time = parseInt(time) * 1000
	} else {
		time = +time
	}
	const d = new Date(time)
	const now = Date.now()

	const diff = (now - d) / 1000

	if (diff < 30) {
		return '刚刚'
	} else if (diff < 3600) {
		return Math.ceil(diff / 60) + '分钟前'
	} else if (diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前'
	} else if (diff < 3600 * 24 * 2) {
		return '1天前'
	}
	if (option) {
		return parseTime(time, option)
	} else {
		return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
	}
}

export function resolveAssetsURL(path) {
	if (!path || (typeof path !== 'string')) return "";
	if (path.startsWith('data:image')) return path
	if (path.startsWith('blob:')) return path
	return assetsURL + path;
}
